import { z } from "zod"

import type { DashboardWidget, DashboardWidgetConfig } from "../types/core"

const nonEmptyStringSchema = z
  .string()
  .refine((value) => value.trim().length > 0)

const nullableNumberSchema = z.number().nullable().optional()

const dashboardWidgetConfigSchema: z.ZodType<DashboardWidgetConfig> = z
  .object({})
  .catchall(z.unknown())

const dashboardWidgetSchema: z.ZodType<DashboardWidget> = z
  .object({
    id: nonEmptyStringSchema,
    type: nonEmptyStringSchema,
    title: nonEmptyStringSchema,
    config: dashboardWidgetConfigSchema.optional(),
    grid_x: nullableNumberSchema,
    grid_y: nullableNumberSchema,
    grid_w: nullableNumberSchema,
    grid_h: nullableNumberSchema,
  })
  .passthrough()

export function hasNonEmptyString(value: unknown): value is string {
  return nonEmptyStringSchema.safeParse(value).success
}

export function asDashboardWidgetConfig(
  value: unknown,
): DashboardWidgetConfig | undefined {
  const result = dashboardWidgetConfigSchema.safeParse(value)
  return result.success ? result.data : undefined
}

export function isDashboardWidget(value: unknown): value is DashboardWidget {
  return dashboardWidgetSchema.safeParse(value).success
}

export function parseImportedDashboardWidgets(
  value: unknown,
): DashboardWidget[] | null {
  const result = z.array(dashboardWidgetSchema).safeParse(value)
  return result.success ? result.data : null
}
